import React from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { Select } from "components"
// import classes from "./BranchSelectFilter.module.scss"

const BranchSelectFilter = props => {
  const {
    isMulti,
    value,
    error,
    className,
    onChange,
    isClearable = true
  } = props

  const [t] = useTranslation()

  const userBranches =
    useSelector(state => state.userAccountInfo.userBranches)

  const handleChange = (select) => {
    if (isMulti) return onChange(select)

    if (!select) return onChange(null)

    if (select.value === selectValue?.value) return

    onChange(select)
  }

  const getSelectedValue = () => {
    if (!isMulti) {
      return userBranchesOptions.find(option => option.value === value) || null
    }

    const values = []

    value.forEach(value => {
      const option =
        userBranchesOptions.find(o => o.value === value)

      if (!!option) values.push(option)
    })

    return values
  }

  const userBranchesOptions =
    userBranches?.map(userBranch => ({
      label: `${userBranch.name} ${userBranch.isOnline ? `(${t("آنلاین")})` : ""}`,
      value: userBranch._id
    })) || []

  if (userBranches?.length <= 1) return null

  const selectValue = getSelectedValue()

  return (
    <Select
      isSearchable={false}
      isMulti={isMulti}
      isClearable={isClearable}
      noOptionsMessage={() => null}
      label={isMulti ? t("شعبات") : t("شعبه")}
      placeholder={t("شعبه_را_انتخاب_کنید")}
      options={userBranchesOptions}
      className={className}
      onChange={handleChange}
      value={selectValue}
      error={error}
    />
  )
}

export default BranchSelectFilter